import React from 'react';
import { TFunction } from 'react-i18next';
import { CopyToClipboard, withInject } from '@piwikpro/platform';
import {
  Information,
  TextField,
  ModalView,
  Stack,
  withTranslation,
} from '@piwikpro/ui-components';
import { OAuthService } from '@piwikpro/oauth-crate';
import { ICredentialsGenerateState } from '../../../../redux/credentials/generate';

interface InjectedProps {
  oauth: OAuthService
}

export interface Props extends InjectedProps {
  finish: () => void
  client: ICredentialsGenerateState['client']
  t: TFunction
}

class DisplayCredentials extends React.Component<Props> {
  async componentDidMount() {
    const { oauth } = this.props;

    return oauth.findClients();
  }

  render() {
    const {
      finish,
      client,
      t,
    } = this.props;
    return (
      <ModalView
        title={t('credentials.display.title')}
        onClose={finish}
      >
        <Stack vertical horizontalAlignment="fill" spacing="wide">
          <Stack.Item>
            <Information type="warning">
              {t('credentials.display.warning') as string}
            </Information>
          </Stack.Item>
          <Stack.Item>
            <Stack vertical spacing="narrow">
              <Stack.Item fill>
                <TextField
                  label={t('credentials.display.field.clientId')}
                  name="clientId"
                  value={client.id!}
                  disabled
                />
              </Stack.Item>
              <Stack.Item>
                <CopyToClipboard text={client.id} />
              </Stack.Item>
            </Stack>
          </Stack.Item>
          <Stack.Item>
            <Stack vertical spacing="narrow">
              <Stack.Item fill>
                <TextField
                  label={t('credentials.display.field.clientSecret')}
                  value={client.secret!}
                  name="clientSecret"
                  disabled
                />
              </Stack.Item>
              <Stack.Item>
                <CopyToClipboard text={client.secret} />
              </Stack.Item>
            </Stack>
          </Stack.Item>
        </Stack>
      </ModalView>
    );
  }
}

export default withInject<InjectedProps>({
  oauth: 'OAuthCrate.oauth',
})(withTranslation('profile')(DisplayCredentials));
